/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import { isNil } from 'lodash';

import {
  dashboardTuitionLink,
  dashboardVideoLink,
  getStartedGoTuitionLink,
  learnMoreGoTuitionLink,
  linkBuilder
} from 'services/Externals';

export const ALASKA_529 = 'alaska529';
export const ALASKA_529_ONLY = 'alaska529Only';
export const MARYLAND_529 = 'maryland529';
export const MARYLAND_529_ONLY = 'maryland529Only';
export const NATIONAL_529 = 'national529';
export const NATIONAL_529_ONLY = 'national529Only';

const educationImageType = {
  [ALASKA_529]: 'AlaskaEducationPlanningCenter',
  [ALASKA_529_ONLY]: 'AlaskaEducationPlanningCenter'
};

const tuitionImageType = {
  [MARYLAND_529]: 'MarylandGoTuition',
  [MARYLAND_529_ONLY]: 'MarylandGoTuition',
  [ALASKA_529]: 'AlaskaGoTuition',
  [ALASKA_529_ONLY]: 'AlaskaGoTuition'
};

export const COLLEGE_SAVINGS_ACCOUNTS = [
  {
    title: 'T. Rowe Price College Savings Plan',
    account: NATIONAL_529
  },
  {
    title: 'Maryland Senator Edward J. Kasemeyer College Investment Plan',
    account: MARYLAND_529
  },
  {
    title: 'Alaska 529',
    account: ALASKA_529
  }
];

const productTypes = (view, isCustodian) => {
  const {
    hasOwnedMaryland529,
    hasOwnedMaryland529Only,
    hasOwnedAlaska529Only,
    hasOwnedAlaska529,
    hasOwnedNational529Only,
    hasOwnedNational529
  } = view;

  const products = [];

  if (hasOwnedMaryland529Only || hasOwnedMaryland529 ||isCustodian ) {
    products.push(MARYLAND_529);
  }

  if (hasOwnedNational529Only || hasOwnedNational529) {
    products.push(NATIONAL_529);
  }

  if (hasOwnedAlaska529Only || hasOwnedAlaska529) {
    products.push(ALASKA_529);
  }
  return products;
};

export const video = (view, productType) => {
  const { hasMaryland529Video, hasNational529Video } = view;

  const hasVideo =
    (productType === MARYLAND_529 && hasMaryland529Video) ||
    (productType === NATIONAL_529 && hasNational529Video);

  return hasVideo
    ? {
        imageType: 'Video',
        title:
          '<strong>Check out your personalized college savings video</strong>',
        content:
          'We have created this personalized college savings video to help you understand your college savings accounts and provide tips on how you can reach your savings goals.',
        linkUrls: {
          watchVideoNow: linkBuilder(dashboardVideoLink[productType], view)
        }
      }
    : {};
};

export const tuition = (view, productType) => {
  const linkUrls = {
    ...tuitionLinks(view, productType)
  };
  return {
    imageType: tuitionImageType[productType] || 'NationalGoTuition',
    title: '<strong>GoTuition<sup>&#0174;</sup></strong> Gifting Portal',
    content:
      'The easy way for family and friends to give the gift of education.',
    linkUrls
  };
};

export const education = (view, productType) => {
  const { hasAlaska529, hasMaryland529, hasNational529 } = view;

  const getCardProduct = (cardProductType) => {
    /*
     AK only – show AK
     NTL only – show NTL
     MD only – show nothing
     AK/NTL crossover – show AK
     AK/MD crossover – show AK
     NTL/MD crossover – show NTL
     AK/NTL/MD crossover – show AK
     */

    if (
      cardProductType === ALASKA_529 &&
      hasNational529 &&
      hasMaryland529 &&
      hasAlaska529
    ) {
      return ALASKA_529;
    }
    if (cardProductType === ALASKA_529 && hasAlaska529 && hasNational529) {
      return ALASKA_529;
    }
    if (cardProductType === ALASKA_529 && hasAlaska529 && hasMaryland529) {
      return ALASKA_529;
    }
    if (cardProductType === NATIONAL_529 && hasAlaska529) {
      return;
    }
    if (cardProductType === NATIONAL_529 && hasNational529 && hasMaryland529) {
      return NATIONAL_529;
    }
    if (cardProductType === NATIONAL_529 && hasNational529) {
      return NATIONAL_529;
    }
    if (cardProductType === ALASKA_529 && hasAlaska529) {
      return ALASKA_529;
    }
  };

  const cardBranding = getCardProduct(productType);

  const showCard = productType !== MARYLAND_529 && !isNil(cardBranding);

  return showCard
    ? {
        imageType:
          educationImageType[cardBranding] || 'NationalEducationPlanningCenter',
        title:
          '<strong>A passport to education from crawlers to scholars.</strong>',
        content:
          "Plan your family's education journey today with the <strong>Education Planning Center</strong> portal.",
        linkUrls: {
          visitEducationPlanningCenter: ''
        }
      }
    : {};
};

const tuitionLinks = (view, productType) => {
  const {
    hasAlaska529GiftIndicator,
    hasMaryland529GiftIndicator,
    hasNational529GiftIndicator
  } = view;

  const getGiftingIndicator = () => {
    if (productType === MARYLAND_529) {
      return hasMaryland529GiftIndicator;
    }

    if (productType === ALASKA_529) {
      return hasAlaska529GiftIndicator;
    }
    if (productType === NATIONAL_529) {
      return hasNational529GiftIndicator;
    }
    return false;
  };

  const hasGiftingIndicator = getGiftingIndicator();

  let links = !hasGiftingIndicator
    ? {
        getStarted: getStartedGoTuitionLink[productType],
        learnMore: learnMoreGoTuitionLink[productType]
      }
    : {};

  const dashboard = hasGiftingIndicator
    ? { viewDashboard: dashboardTuitionLink[productType] }
    : {};

  links = {
    ...links,
    ...dashboard
  };

  return links;
};

export const personalizedServices = (view, isCustodian ) => {
  return {
    productTypes: productTypes(view, isCustodian)
  };
};
